import React, { useState } from "react";
import Harianusp from "./pdf/Harianusp";
//import TransaksiUmum from "./pdf/transaksiumum";
import { useGlobalContext } from "../../GlobalContext";

const HarianUSP = () => {
  const { api } = useGlobalContext();

  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  // ======== USP ========
  const fetchUSP = async () => {
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return null;
    }
    try {
      const response = await api.get(`/api/laporan/saham/${startDate}/${endDate}`);
      const data = response.data?.data || response.data;
      if (!data || data.length === 0) {
        alert("Tidak ada data USP untuk dicetak pada Tanggal Tersebut.");
        return null;
      }
      return data;
    } catch (error) {
      alert("Gagal mengambil data USP.");
      console.error("Fetch USP error:", error);
      return null;
    }
  };

  const handlePrintUSP = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Mulai loading
    try {
      const data = await fetchUSP();
      if (data) {
        Harianusp(data, startDate, endDate);
      }
    } finally {
      setIsLoading(false); // Selesai loading, apa pun hasilnya
    }
  };


  const handleExportExcel = async (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Silakan pilih tanggal mulai dan akhir.");
      return;
    }
    setIsExporting(true);
    const endpoint = `/saham/excel/${startDate}/${endDate}`; // sesuai router: /api/laporan + this route

    try {

      const resp = await api.get(`/api/laporan${endpoint}`, {
        responseType: "blob",        
      });

      const cd = resp.headers["content-disposition"];
      let filename = `Laporan_USP_${startDate}_sampai_${endDate}.xlsx`;
      if (cd) {
        const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i);
        if (m && m[1]) filename = decodeURIComponent(m[1]);
      }

      const blob = new Blob([resp.data], { type: resp.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      alert("Excel berhasil diunduh!");
    } catch (error) {
      console.error("Export Excel error:", error);
      alert("Tidak ada data USP untuk dicetak pada Tanggal Tersebut.");
    } finally {
      setIsExporting(false);
    }
  };

  // ======== Render ========
  return (
    <div className="container mt-3">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card card-info">
            <div className="card-header bg-info text-white">
              <h3 className="card-title">Laporan Harian & Transaksi</h3>
            </div>
            <form className="form-horizontal">
              <div className="card-body">
                {/* Input tanggal USP */}
                <div className="form-group row d-flex align-items-center mb-3">
                  <label htmlFor="tglmulai" className="col-sm-3 col-form-label">
                    Laporan USP
                  </label>
                  <div className="col-sm-4">
                    <input
                      type="date"
                      className="form-control"
                      id="tglmulai"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="col-auto">s/d</div>
                  <div className="col-sm-4">
                    <input
                      type="date"
                      className="form-control"
                      id="tglsampai"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
                
              </div>

              {/* tombol Cetak + Export Excel */}
              <div className="card-footer text-right">
                <button
                  onClick={handlePrintUSP}
                  type="button"
                  className="btn btn-sm btn-primary"
                  disabled={isLoading || isExporting}
                >
                  {isLoading ? "Mencari..." : "Cetak Laporan USP"}
                </button>

                <button
                  onClick={handleExportExcel}
                  type="button"
                  className="btn btn-sm btn-success"
                  disabled={isLoading || isExporting}
                  style={{ marginLeft: 8 }}
                >
                  {isExporting ? "Mengekspor..." : "Export Excel"}
                </button>
               
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HarianUSP;